import { TableCell, TableRow, Typography } from "@mui/material";
import { PaginatedTable } from "../../generic/components/paginated-table/paginated-table";

import type { ConnectionKey } from "../server/supabase-connections-key-service";
import type { FC } from "react";

export const ConnectionsDataGrid: FC<{
  connectionKeys: ConnectionKey[];
}> = ({ connectionKeys }) => (
  <>
    <Typography variant="h6" fontWeight={600} sx={{ my: 2 }}>
      Connections
    </Typography>
    <PaginatedTable
      config={{
        headers: ["Key", "Name", "Number of Connections"],
      }}
      data={connectionKeys}
      renderRow={({ key, display_name, quantity }) => (
        <TableRow data-testid="connections-grid-row">
          <TableCell>{key}</TableCell>
          <TableCell>{display_name}</TableCell>
          <TableCell>{quantity}</TableCell>
        </TableRow>
      )}
    />
  </>
);
